module.exports = __webpack_public_path__ + "img/logo.897c5844.png";